import type { AIDTColor } from './_typing';

export const green: AIDTColor = Object.freeze({
  50: '#e8f5e9',
  100: '#E0F0DE',
  200: '#C0E0BD',
  300: '#A1D19C', // english elementary key
  400: '#81C17B',
  500: '#62B25A', // english middle key
  600: '#539D4C',
  700: '#45893E',
  800: '#367431',
  900: '#285F23', //english high bg
  950: '#1B3F17',
  0: '#0D200C', // english high key
} as const);
